import React from 'react';
import CtaSecondaryRight from '../../components/buttons/CtaSecondaryRight';

const BgImgWhiteCorner = (props) => {
  function containerClick() {
    const geoLocale = localStorage.locale;
    if (geoLocale === 'en-GB') {
      window.location.href = `https://ruggable.co.uk${props.href}`;
    } else if (geoLocale === 'de-DE') {
      window.location.href = `https://ruggable.de${props.href}`;
    } else {
      window.location.href = `https://ruggable.com${props.href}`;
    }
  }

  return (
    <div
      id={props.id}
      role='img'
      aria-label={props.ariaLabel}
      title={props.title}
      className='bgImgWhiteCornerContainer'
      style={{ backgroundImage: `url(` + props.img + `)` }}
      onClick={containerClick}
    >
      <div id='bgImgWhiteCorner_whiteBox'>
        <CtaSecondaryRight text={props.text} href={props.href} />
      </div>
    </div>
  );
};

export default BgImgWhiteCorner;
